// PT-BR
export const reservasHc = {
  // ── CheckinsList.vue ──────────────────────────────────────────────────────
  checkinsList: {
    newCheckin: "Novo check-in",
    manualDispatchTitle: "Fechamento manual do envio final",
    manualDispatchText:
      "Se um dos hóspedes não for viajar, você pode fechar manualmente este processo para enviar agora a mensagem de boas-vindas, as chaves digitais e o documento ao responsável pela reserva.",
    sending: "Enviando...",
    completeManualSend: "Concluir manualmente e enviar",
    finalSendProcessed: "Envio final já processado",
    arrivalInstructions: "Instruções de chegada",
    arrivalAlreadySent: "Já enviadas. Você pode reenviá-las ao hóspede agora se precisar.",
    arrivalAutoInfo:
      "São enviadas automaticamente no horário. Você pode antecipá-las e enviá-las agora (mensagem, acessos e arquivos configurados).",
    resendNow: "Reenviar agora",
    sendNow: "Enviar agora",

    titleEditCheckin: "Editar check-in",
    titleDeleteCheckin: "Excluir check-in",

    confirmManualTitle: "Concluir o envio manualmente?",
    confirmManualMsg:
      "Use esta ação quando não houver mais hóspedes fazendo check-in e você precisar enviar agora as informações finais ao responsável pela reserva.",
    yesSendNow: "Sim, enviar agora",
    cancel: "Cancelar",
    manualSendFailed: "Não foi possível concluir o envio manual.",
    sendProcessedTitle: "Envio processado",
    finalInfoProcessed: "As informações finais do check-in já foram processadas.",
    couldNotSend: "Não foi possível enviar",

    confirmResendArrivalTitle: "Reenviar instruções de chegada?",
    confirmSendArrivalTitle: "Enviar instruções de chegada agora?",
    confirmResendArrivalMsg:
      "As instruções de chegada já foram enviadas. Deseja enviá-las novamente ao hóspede agora?",
    confirmSendArrivalMsg:
      "As instruções de chegada (mensagem, acessos e arquivos configurados) serão enviadas ao hóspede agora, sem esperar o horário programado.",
    arrivalSendFailed: "Não foi possível enviar as instruções de chegada.",
    pendingDeliveryTitle: "Entrega pendente",
    instructionsSentTitle: "Instruções enviadas",
    arrivalSentToGuest: "As instruções de chegada foram enviadas ao hóspede.",

    stepGuestData: "Dados do hóspede",
    stepSignature: "Assinatura",
    stepRegistered: "Check-in registrado",

    sectionPersonal: "Dados pessoais",
    sectionStay: "Estadia",
    sectionDocument: "Documento",

    nombre: "Nome",
    apellido: "Sobrenome",
    sexo: "Sexo",
    select: "Selecione",
    male: "Masculino",
    female: "Feminino",
    preferNotToSay: "Prefiro não dizer",
    other: "Outro",
    birthDate: "Data de nascimento",
    minorsTraveling: "Viajam menores nesta reserva?",
    no: "Não",
    yes: "Sim",
    relationshipMinor: "Parentesco do menor",
    relationshipToMinor: "Parentesco em relação ao menor",
    phone: "Telefone",
    email: "E-mail",
    checkInDate: "Data de entrada",
    checkOutDate: "Data de saída",

    nationality: "Nacionalidade",
    cittadinanza: "Cittadinanza / Nacionalidade",
    documentType: "Tipo de documento",
    documentNumber: "Número do documento",
    supportNumber: "Número de suporte",
    docTypes: {
      passport: "Passaporte",
      identityDoc: "Documento de Identidade",
      co_cc: "Cédula de Cidadania",
      co_ce: "Cédula de Estrangeiro",
      co_ppt: "Permissão de Proteção Temporária",
      co_pep: "Permissão Especial de Permanência",
      co_de: "Documento Estrangeiro",
    },
    relationships: {
      co: {
        PADRE: "Pai",
        MADRE: "Mãe",
        HIJO: "Filho(a)",
        ABUELO: "Avô/Avó",
        HERMANO: "Irmão/Irmã",
        TIO: "Tio/Tia",
        TUTOR: "Tutor(a) legal",
        OTRO: "Outro",
      },
      es: {
        HJ: "Filho(a)",
        AB: "Avô/Avó",
        BA: "Bisavô/Bisavó",
        BN: "Bisneto(a)",
        CD: "Cunhado(a)",
        CY: "Cônjuge",
        HR: "Irmão/Irmã",
        NI: "Neto(a)",
        OT: "Outro",
        PM: "Pai/Mãe",
        SB: "Sobrinho(a)",
        SG: "Sogro(a)",
        TI: "Tio/Tia",
        TU: "Tutor(a)",
        YN: "Genro/Nora",
      },
    },

    italyBannerTitle: "Dados exigidos na Itália · Alloggiati Web",
    italyBannerText:
      "A Polizia di Stato exige o estado de nascimento, o município de nascimento e o local de emissão do documento.",
    sectionBirthData: "Dados de nascimento",
    statoNascita: "Stato di nascita / País de nascimento",
    birthStateHint: "O estado de nascimento pode ser diferente da nacionalidade.",
    comuneNascita: "Município de nascimento",
    luogoRilascio: "Local de emissão do documento",
    luogoRilascioHint: "Município italiano ou Estado estrangeiro que emitiu o documento.",
    searchCittadinanza: "Buscar a cidadania…",
    searchStatoNascita: "Buscar o estado de nascimento…",
    searchComuneNascita: "Buscar o município de nascimento…",
    searchComuneRilascio: "Município de emissão…",
    searchStatoRilascio: "Estado de emissão…",

    sectionSes: "Dados SES Hospedajes",
    countryResidence: "País de residência",
    cityResidence: "Cidade de residência",
    address: "Endereço",
    zipCode: "Código postal",
    paymentMethod: "Forma de pagamento",
    paymentDate: "Data de pagamento",
    pay: {
      efectivo: "Dinheiro",
      destino: "Pagamento no destino",
      tarjeta: "Cartão",
      movil: "Pagamento móvel",
      plataforma: "Plataforma",
      transferencia: "Transferência",
    },

    sireLegalTitle: "SIRE & TRA — Aviso Legal",
    sireLegalText:
      "Para estabelecimentos na Colômbia, as informações solicitadas são coletadas conforme a regulamentação da Migración Colombia (SIRE) e o registro de hóspedes (TRA).",
    sectionSire: "Dados SIRE / TRA",
    searchNationality: "Buscar nacionalidade...",
    searchCountry: "Buscar país...",
    noResults: "Sem resultados",
    countryOrigin: "País de procedência",
    searchCountryOrigin: "Buscar país de procedência...",
    cityOrigin: "Cidade de procedência",
    searchCity: "Buscar cidade...",
    searchMunicipality: "Buscar município...",
    nextDestinationCountry: "País do próximo destino",
    searchDestinationCountry: "Buscar país de destino...",
    summaryOrigin: "Procedência",
    summaryDestination: "Destino",

    sectionIdentity: "Verificação de identidade",
    recommended: "recomendado",
    identityActiveInfo:
      "A propriedade tem verificação de identidade ativa. Envie fotos do documento do hóspede.",
    documentFront: "Frente do documento",
    uploadPhoto: "Enviar foto",
    selfieGuest: "Selfie do hóspede",
    altDocumentFront: "Frente do documento",
    altMinorAuth: "Autorização do menor",
    titleRemove: "Excluir",

    sectionMinorDocs: "Documentação do menor",
    optional: "opcional",
    minorInfo: "Para menores de idade, você pode enviar a autorização de viagem ou o documento do responsável.",
    guardianAuthDoc: "Autorização / Documento do responsável",
    uploadDocument: "Enviar documento",

    sectionSignature: "Assinatura do hóspede",
    signatureHint: "Peça ao hóspede que assine no quadro para aceitar os termos da acomodação.",
    undo: "Desfazer",
    clear: "Limpar",
    termsAccept: "O hóspede aceita os termos e condições da acomodação",

    successTitle: "Check-in registrado!",
    successBefore: "O check-in de",
    successAfter: "foi salvo com sucesso.",

    next: "Avançar",
    back: "Voltar",
    saving: "Salvando...",
    saveCheckin: "Salvar check-in",
    close: "Fechar",

    vNombre: "O nome é obrigatório",
    vApellido: "O sobrenome é obrigatório",
    vSexo: "O sexo é obrigatório",
    vBirthDate: "A data de nascimento é obrigatória",
    vPhone: "O telefone é obrigatório",
    vCheckIn: "A data de entrada é obrigatória",
    vCheckOut: "A data de saída é obrigatória",
    vNationality: "A nacionalidade é obrigatória",
    vDocType: "O tipo de documento é obrigatório",
    vDocNumber: "O número do documento é obrigatório",
    vEmailFormat: "O e-mail não tem um formato válido",
    vDocSupport: "O número de suporte do documento é obrigatório",
    vMinors: "Indique se viajam menores na reserva",
    vRelationship: "O parentesco do menor acompanhante é obrigatório",
    vCountryResidence: "O país de residência é obrigatório",
    vCityResidence: "A cidade de residência é obrigatória",
    vAddress: "O endereço é obrigatório",
    vZip: "O código postal é obrigatório",
    vPaymentMethod: "A forma de pagamento é obrigatória",
    vPaymentDate: "A data de pagamento é obrigatória",
    vCountryOrigin: "O país de procedência é obrigatório",
    vNextDest: "O país do próximo destino é obrigatório",
    vCityOrigin: "A cidade de procedência é obrigatória",
    vStatoNascita: "O estado de nascimento (Stato di nascita) é obrigatório",
    vComuneNascita: "O município de nascimento (Comune di nascita) é obrigatório",
    vLuogoRilascio: "O local de emissão do documento (Luogo di rilascio) é obrigatório",

    vTerms: "Você deve aceitar os termos para continuar",
    vSignaturePad: "Erro ao acessar o painel de assinatura",
    vSignature: "A assinatura é obrigatória",
    saveCheckinError: "Ocorreu um erro ao salvar o check-in",
    saveCheckinErrorGeneric: "Erro ao salvar o check-in",
    socketCheckinDone: "<strong>{name}</strong> concluiu o check-in manual",
    identityPhotosError: "O check-in foi salvo, mas não foi possível enviar as fotos de identidade",
    minorAuthError: "O check-in foi salvo, mas não foi possível enviar a autorização do menor",

    docDni: "DNI inválido. Deve ter 8 dígitos seguidos da letra de controle correta (ex: 12345678Z)",
    docNie: "NIE inválido. Formato: X/Y/Z + 7 dígitos + letra de controle (ex: X1234567Z)",
    docPassport: "Passaporte inválido. Deve ter entre 6 e 20 caracteres alfanuméricos",
    docCc: "Cédula de Cidadania inválida. Deve ter entre 6 e 10 dígitos",
    docCe: "Cédula de Estrangeiro inválida. Deve ter entre 6 e 12 caracteres alfanuméricos",
    docPptPep: "{tipo} inválido. Deve ter entre 4 e 15 caracteres alfanuméricos",

    zipNotFound: "Código postal não encontrado. Verifique o número e tente novamente.",
  },

  // ── PageReservation.vue ───────────────────────────────────────────────────
  pageReservation: {
    requestPendingTitle: "Solicitação de reserva pendente",
    requestPendingText:
      "O hóspede solicitou estas datas. O calendário não fica bloqueado até você aprovar.",
    approving: "Aprovando…",
    approve: "Aprovar",
    rejecting: "Recusando…",
    reject: "Recusar",
    requestRejectedTitle: "Solicitação recusada",
    requestRejectedText: "Esta solicitação foi recusada pela acomodação e não pode mais ser confirmada.",
    awaitingPaymentTitle: "Aguardando pagamento do hóspede",
    awaitingPaymentText:
      "O calendário está bloqueado temporariamente. Se não houver pagamento, a disponibilidade é liberada automaticamente.",
    remaining: "restante",
    marking: "Marcando...",
    markAsPaid: "Marcar como paga",
    expiring: "Expirando...",
    markAsExpired: "Marcar como expirada",

    extensionPendingTitle: "Prorrogação de estadia pendente",
    extraNights: "{count} noite(s) extra",
    newCheckout: "nova saída",
    awaitingGuestPayment: "aguardando o pagamento do hóspede",
    holdLeftMinutes: "faltam {min} min para pagar",
    holdLeftSeconds: "faltam {seg} s para pagar",
    holdExpired: "o prazo expirou: as noites foram liberadas",
    pendingApproval: "pendente de aprovação",
    confirming: "Confirmando...",

    observation: "Observação",

    pendingCharge: "pendente de cobrança",
    processing: "Processando...",

    clientRequested: "O cliente solicitou:",
    serviceFallback: "Serviço",
    toConsult: "sob consulta",

    approveRequestTitle: "Aprovar solicitação",
    amountToCharge: "Valor a cobrar",
    noCharge: "0 = sem cobrança",
    approveHint:
      "Se você tiver um gateway conectado, um <strong>link de pagamento</strong> é enviado ao hóspede (WhatsApp + e-mail). Caso contrário, é informado que ele <strong>pagará na chegada</strong>.",
    cancel: "Cancelar",
    close: "Fechar",
    approveAndNotify: "Aprovar e avisar",

    reservationTotal: "Total da reserva:",
    onRequestPaidSeparately: `os itens "sob consulta" são pagos à parte`,
    fullPayment: "Pagamento total",
    noBalance: "(sem saldo)",
    deposit: "Adiantamento",
    balance: "saldo",
    markPaidHint: `O valor escolhido é registrado como cobrado. O "total" cobre estadia, limpeza e serviços com preço (ex.: Uber); os itens "sob consulta" têm sua própria cobrança.`,
    confirm: "Confirmar",

    paymentExpiredTitle: "Tempo de pagamento expirado",
    paymentExpiredText: "A reserva temporária expirou e a disponibilidade foi liberada automaticamente.",

    overbookingTitle: "Reserva em overbooking",
    overbookingText:
      "As datas dela conflitam com outra reserva desta acomodação. As datas continuam bloqueadas nas OTAs. Se você já resolveu o conflito (cancelou ou moveu a outra reserva), confirme aqui.",
    verifying: "Verificando...",
    confirmReservation: "Confirmar reserva",

    checkinInvitation: "Convite de check-in",
    copyCheckinLink: "Copiar link de check-in",
    editReservation: "Editar reserva",

    codesAndAccess: "Códigos e acessos",
    codesAndAccessSub: "Senhas e links de acesso do hóspede",
    currentAccessCodes: "Códigos de acesso atuais:",
    currentAccessCode: "Código de acesso atual:",
    guestDigitalAccess: "Acesso digital do hóspede",
    copyOpenLink: "Copiar link de abertura",
    copy: "Copiar",
    openLink: "Abrir link de abertura",
    open: "Abrir",
    yacanNote: "O acesso desta reserva é gerenciado pela <b>YACAN</b> automaticamente com suas fechaduras.",
    digitalKeyEkey: "Chave digital (ekey)",
    openDigitalKey: "Abrir chave digital",
    previousCodesExpired: "Códigos anteriores (já expirados):",
    sentOn: "enviado em",
    generated: "gerado",
    expiredOn: "expirou em",

    amountAndPayment: "Valor e pagamento",
    amountAndPaymentSub: "Detalhamento, status da cobrança e faturamento",

    guestJourney: "Jornada do hóspede",
    eventsCount: "{count} evento | {count} eventos",
    journeySubtitle: "Rastreabilidade completa desde a reserva até a saída",
    stagesCompleted: "etapas concluídas",
    nextLabel: "Próximo:",
    // Cabecera del bloque de etapas que aún no han ocurrido; van FUERA de la cronología.
    pendingAhead: "O que falta",
    // El envío del parte a las autoridades: cada servicio lo apunta en historial_firmas.
    authoritiesTitle: "Boletim de alojamento",
    authoritiesAction: "foi comunicado às autoridades",
    authoritiesDesc: "Enviado a {services}",
    viewInChat: "Ver no chat",

    accessCode: "Código de acesso",
    accessCodeSub: "Edite e envie a senha ao hóspede",
    currentlyConfiguredCode: "Código configurado atualmente",
    newCode: "Novo código",
    keepSameToResend: "deixe igual para reenviar sem alterações",
    placeholderCode: "Ex.: ABCD1234",
    codeSavedUppercaseHint: "O código será salvo em maiúsculas e enviado por WhatsApp e/ou e-mail.",
    sending: "Enviando...",
    saveAndSendToGuest: "Salvar e enviar ao hóspede",

    resendAccess: "Reenviar acesso",
    sendAccess: "Enviar acesso",
    resendPin: "Reenviar PIN",
    sendPin: "Enviar PIN",
    activating: "Ativando...",
    resendCode: "Reenviar código",
    sendAccessCode: "Enviar código de acesso",

    channelManager: "channel manager",
    directBooking: "reserva direta",
    directTag: "Direta",
    bookingRegistered: "Reserva registrada",
    bookedViaOta: "reservou via OTA",
    createdBooking: "criou a reserva",
    incomingVia: "Entrada via {channel}",
    confirmedTag: "Confirmada",
    pendingTag: "Pendente",
    bookingConfirmed: "Reserva confirmada",
    pendingConfirmation: "Pendente de confirmação",
    receivedConfirmation: "recebeu a confirmação da reserva",
    awaitingConfirmationAction: "está pendente de confirmação",
    propertyConfirmed: "A acomodação confirmou a reserva",
    awaitingConfirmationDesc: "Aguardando confirmação",
    sentTag: "Enviada",
    notSentTag: "Não enviada",
    checkinInvitationTitle: "Convite de check-in",
    receivedCheckinInvite: "recebeu o convite de check-in",
    notReceivedCheckinInvite: "ainda não recebeu o convite de check-in",
    checkinLinkSent: "Link de check-in enviado ao hóspede",
    inviteNotSentYet: "O convite ainda não foi enviado",
    completedTag: "Concluído",
    checkinOnline: "Check-in online",
    didCheckinOnline: "fez o check-in online",
    notYetCheckinOnline: "ainda não fez o check-in online",
    guestsRegistered: "{count} hóspede(s) registrado(s)",
    guestNotCompletedCheckin: "O hóspede ainda não concluiu o check-in",
    sentTagPlural: "Enviados",
    accessCodes: "Códigos de acesso",
    receivedAccessCodes: "recebeu os códigos de acesso",
    notReceivedAccessCodes: "ainda não recebeu os códigos de acesso",
    accessKeysSent: "Senhas de acesso enviadas ao hóspede",
    pendingSendAccess: "Pendente de envio dos acessos",
    finishedTag: "Finalizada",
    plannedTag: "Previsto",
    guestCheckout: "Saída do hóspede",
    finishedStay: "finalizou a estadia",
    plannedCheckout: "tem a saída prevista",
    stayFinished: "A estadia foi finalizada",
    autoCheckoutScheduled: "Check-out automático programado",
    theGuest: "O hóspede",
    theTeam: "A equipe",
    theChannel: "O canal",
    theSystem: "O sistema",
    calledFromNumber: "ligou do número {phone}",

    filterAll: "Tudo",
    filterWhatsapp: "WhatsApp",
    filterCalls: "Chamadas",
    filterCheckin: "Check-in",
    filterAccess: "Acesso",
    filterBooking: "Reserva",

    error: "Erro",
    requestApprovedMsg: "Solicitação aprovada. A reserva está confirmada.",
    requestApprovedTitle: "✓ Aprovada",
    couldNotApprove: "Não foi possível aprovar.",
    confirmRejectRequestMsg: "Tem certeza de que deseja recusar esta solicitação? Não é possível desfazer.",
    rejectRequestHeader: "Recusar solicitação",
    yesReject: "Sim, recusar",
    requestRejectedMsg: "Solicitação recusada.",
    rejectedTitle: "Recusada",
    couldNotReject: "Não foi possível recusar.",
    couldNotLoadOptions: "Não foi possível carregar as opções; o total será marcado.",
    noticeTitle: "Aviso",
    depositMarkedPaid: "Adiantamento marcado como pago. Reserva confirmada com saldo pendente.",
    fullMarkedPaid: "Reserva marcada como paga no total e confirmada.",
    paymentConfirmedTitle: "Pagamento confirmado",
    couldNotMarkPaid: "Não foi possível marcar como paga.",
    tempReservationExpired: "A reserva temporária foi expirada e liberou disponibilidade.",
    reservationExpiredTitle: "Reserva expirada",
    couldNotMarkExpired: "Não foi possível marcar como expirada.",
    extensionMarkedPaid: "A prorrogação foi marcada como paga e confirmada.",
    extensionConfirmedTitle: "Prorrogação confirmada",
    couldNotConfirmExtension: "Não foi possível confirmar a prorrogação.",
    extensionCancelled: "A prorrogação foi cancelada e a disponibilidade foi liberada.",
    extensionRejectedTitle: "Prorrogação recusada",
    couldNotRejectExtension: "Não foi possível recusar a prorrogação.",
    chargeMarkedPaid: "A cobrança foi marcada como paga.",
    chargeRegisteredTitle: "Cobrança registrada",
    couldNotMarkChargePaid: "Não foi possível marcar a cobrança como paga.",
    chargeRejected: "A cobrança foi recusada e removida da reserva.",
    chargeRejectedTitle: "Cobrança recusada",
    couldNotRejectCharge: "Não foi possível recusar a cobrança.",
    approvedState: "Aprovado",
    rejectedState: "Recusado",
    paidState: "Pago",
    pendingYourResponse: "Pendente da sua resposta",
    enterValidAmount: "Indique um valor válido (0 = sem cobrança).",
    amountTitle: "Valor",
    approvedPaymentLinkSent: "Aprovada. O link de pagamento foi enviado ao hóspede (WhatsApp + e-mail).",
    serviceApprovedTitle: "Serviço aprovado",
    approvedPayOnArrival: "Aprovada. O hóspede pagará na chegada (sem gateway conectado).",
    approvedGuestNotified: "Aprovada. O hóspede foi avisado.",
    couldNotApproveRequest: "Não foi possível aprovar a solicitação.",
    requestRejectedNotified: "Solicitação recusada. O hóspede foi avisado.",
    serviceRejectedTitle: "Serviço recusado",
    couldNotRejectRequest: "Não foi possível recusar a solicitação.",
    resendAccessLinkMsg: "Deseja reenviar o link de acesso pelos canais disponíveis?",
    sendAccessLinkMsg: "Deseja enviar o link de acesso pelos canais disponíveis?",
    resendPinMsg:
      "Deseja reenviar o código de acesso pelos canais disponíveis? Um novo PIN será gerado.",
    sendPinMsg: "Deseja gerar e enviar o código de acesso pelos canais disponíveis?",
    sendDigitalAccessHeader: "Enviar Acesso Digital",
    sendPinHeader: "Enviar PIN de Acesso",
    send: "Enviar",
    accessLinkSent: "Link de acesso enviado ao hóspede",
    accessSentTitle: "Acesso Enviado",
    successSummary: "Sucesso",
    digitalAccessSentDetail: "O acesso digital foi enviado para {count} dispositivo(s)",
    ttlockCodesGenerated: "{count} códigos TTLock foram gerados e processados para a reserva.",
    accessCodeResent: "Código de acesso reenviado: {code}",
    accessCodeGeneratedSent: "Código de acesso gerado e enviado: {code}",
    pinSentTitle: "PIN Enviado",
    pinProcessedDetail: "O PIN foi processado para {count} fechadura(s)",
    pinProcessedBlebox: "e {count} porta(s) eletrônica(s)",
    couldNotSendAccessCode: "Não foi possível enviar o código de acesso",
    codeCopied: "Código copiado para a área de transferência",
    mainGate: "Portão principal",
    accommodation: "Acomodação",
    doorLabel: "Porta da acomodação",
    validUntil: "Válido até: {date}",
    earlyAccessLinkMsg:
      "Isto ativará o link de acesso imediatamente (antes do horário normal de check-in).",
    earlyAccessPinMsg: "Isto ativará o PIN imediatamente (antes do horário normal de check-in).",
    earlyAccessHeader: "Acesso antecipado",
    activate: "Ativar",
    earlyAccessActivated: "Acesso antecipado ativado",
    okSummary: "OK",
    earlyAccessActivatedDetail: "O acesso antecipado foi ativado",
    couldNotActivateEarlyAccess: "Não foi possível ativar o acesso antecipado",
    cancelReservationMsg:
      "A reserva será cancelada por completo. Se ocupar vários quartos (mesmo de tipos diferentes), todos serão cancelados e liberados. Esta ação não pode ser desfeita.",
    goBack: "Voltar",
    resolveOverbookingMsg:
      "Será verificado que não há mais conflito com outra reserva. Se estiver livre, a reserva passará a confirmada e suas datas continuarão bloqueadas nas OTAs.",
    confirmOverbookingHeader: "Confirmar reserva em overbooking",
    reservationConfirmed: "Reserva confirmada.",
    couldNotConfirmReservation: "Não foi possível confirmar a reserva.",
    reservationCancelledFreed: "Reserva cancelada. {count} quartos foram liberados.",
    otaLangPrompt:
      "Esta reserva OTA não tem telefone. Indique o idioma da mensagem para enviar o check-in pelo chat da OTA: es, en, fr, pt, ar, it, de",
    inviteProcessedEmailOta: "Convite processado. Também enviado por e-mail e chat da OTA.",
    inviteProcessedOta: "Convite processado. Também enviado pelo chat da OTA.",
    inviteProcessedEmail: "Convite processado. Também enviado por e-mail.",
    couldNotSendCheckinInvite: "Não foi possível enviar o convite de check-in",
    couldNotLoadConversations: "Não foi possível carregar as conversas",
    reservationUpdatedShort: "Reserva atualizada",
    couldNotUpdateReservation: "Não foi possível atualizar a reserva",
    codeEmpty: "O código não pode estar vazio",
    attentionTitle: "Atenção",
    accessCodeProcessed: "Código de acesso processado com sucesso",
    sentCheckTitle: "Enviado ✓",
    accessCodeSendProcessed: "O envio do código de acesso foi processado.",
    couldNotSendCode: "Não foi possível enviar o código",
    chatOta: "chat da OTA",
    emailChannel: "e-mail",
    channelsUsed: "Canais utilizados: {channels}.",
  },

  // ── HotelReservationModal.vue ─────────────────────────────────────────────
  telefonoDelHuesped: {
    noValido: "Este telefone não parece válido para {pais}. Se o hóspede for de outro país, troque a bandeira. Clique em salvar de novo para manter assim mesmo.",
  },
  hotelResModal: {
    otaBanner:
      "Reserva OTA: você não pode alterar <strong>datas</strong>, <strong>tipo</strong> nem <strong>quantidade de quartos</strong> pelo WA Checkin. Você deve fazer isso pela OTA (Booking, Airbnb, etc.).",
    otaLock: "Reserva OTA: as datas, o tipo e a quantidade só podem ser alterados pela OTA.",
    close: "Fechar",
    placeholderEmail: "email@exemplo.com",
    roomAbbr: "Qto.",
    fromCalendar: "do calendário",
    noMatches: "Sem correspondências",
    undo: "Desfazer",
    removeRoom: "Remover quarto",
    willBeRemovedOnSave: "Será removido ao salvar as alterações.",
    checkingAvailability: "Verificando disponibilidade…",
    availableCount: "{count} disponível | {count} disponíveis",
    notEnoughAvail: "Disponibilidade insuficiente",
    freeCount: "{count} livre | {count} livres",
    total: "total",
    nightsCount: "{count} noite | {count} noites",
    resendConfirmationTitle: "Reenviar mensagem de confirmação",
    resendConfirmationSub: "Envie novamente o modelo de confirmação ao hóspede.",
    resendConfirmationNote:
      "Ao modificar a reserva, o <strong>modelo de confirmação</strong> desta reserva será reenviado.",
    room: "Quarto",

    noEnoughUnitsFree: "Disponibilidade insuficiente. Unidades livres: {units}.",
    closedPeriodManual: "As datas incluem dias fechados pelo proprietário.",
    noAvailForDates: "Sem disponibilidade para essas datas.",
    selectRoomType: "Selecione um tipo de quarto.",
    selectValidDates: "Selecione datas válidas.",
    enterGuestName: "Informe o nome do hóspede.",
    invalidEmail: "O e-mail não é válido.",
    enterValidPhone: "Informe um telefone válido.",
    noAvailCreateModify: "Sem disponibilidade para criar/modificar com essas datas.",
    aRoom: "um quarto",
    notEnoughAvailIn: "Disponibilidade insuficiente em: {names}.",
    missingOnCreate: "Falta onCreateReservation no componente pai.",
    aRoomType: "um tipo de quarto",
    notEnoughAvailInType: `Disponibilidade insuficiente em "{name}".`,
    sameHotelOnly: "Uma reserva não pode misturar quartos de dois hotéis. Remova os que não são deste hotel.",
    otherHotelLinesDropped: "Os quartos do hotel anterior foram removidos: uma reserva é de um só hotel.",
    partiallyCreated: "Foram criados {ok} de {total} quartos e o seguinte falhou. Verifique a reserva antes de tentar de novo.",
    reservationIdNotFound: "ID da reserva não encontrado.",
    cannotRemoveAll: "Você não pode remover todos os quartos. Para isso, cancele a reserva completa.",
    thisRoom: "este quarto",
    confirmRemoval:
      "Você vai REMOVER da reserva: {names}. Esses quartos são liberados e deixam de ser faturados. Continuar e salvar?",
    couldNotAdd: "Não foi possível adicionar {name}.",
    couldNotUpdate: `Não foi possível atualizar "{name}".`,
    couldNotRemove: `Não foi possível remover "{name}".`,
    couldNotRemovePrimary: "Não foi possível remover o quarto principal.",
    reservationUpdated: "Reserva atualizada com sucesso",
    updatedPartially: "Só se guardou uma parte: confere os quartos da reserva.",
    couldNotUpdateReservation: "Não foi possível atualizar a reserva.",
  },
};
